import React, { useState } from "react";
import { Container } from "react-bootstrap";
import Api from "../api/Api";

const NoteNewNote = ({ name, toggleNewNoteState, parentItem }) => {
  const [modifiedNote, setModifiedNote] = useState({
    model_id: parentItem.id,
    text: "",
    image: null,
    note_type: name,
  });

  const setValue = (field, value) => {
    setModifiedNote({ ...modifiedNote, [field]: value });
  };

  const saveChanges = async () => {
    if (window.confirm("Biztosan beküldi a megjegyzést?")) {

      let param = {
        note:modifiedNote,
        taskId: parentItem.id,
        taskKey: parentItem.guid,
      }

      console.log('insertTaskNote param:');
      console.log(param);
      
      const success = await Api.insertTaskNote(param);
      // sikeres beküldés után kinullázzuk és bezárjuk
      if (success) {
        setModifiedNote({
          model_id: parentItem.id,
          text: "",
          image: null,
          note_type: name,
        });
        toggleNewNoteState(name);
      }
    }
  };

  return (
    <Container className="new-note-block pt-2">
      <label className="mt-2">Új megjegyzés írása</label>
      <textarea
        name="note_text"
        className="my-2 p-2"
        placeholder="Írj egy megjegyzést..."
        value={modifiedNote.text}
        onChange={(e) => setValue("text", e.target.value)}
      ></textarea>

      <div className="note-file-input-outer my-2">
        <input
          type="file"
          name="image"
          className="note-file-input"
          accept="image/*"
          capture="environment"
          onChange={(e) => setValue("image", e.target.files[0])}
        />
      </div>

      <div className="row mt-2 mb-3 p-0">
        <div className="col-4 px-1">
          <button
            className={`btn button w-100 button-gray`}
            onClick={(e) => { toggleNewNoteState(name); }}
          >
            Mégse
          </button>
        </div>
        <div className="col-8 px-1">
          <button className="btn button w-100" onClick={saveChanges}>Mentés</button>
        </div>
      </div>
    </Container>
  );
};

export default NoteNewNote;
